import { mathUtils } from '@festina-life/core'
export const NODE_SPACING_HORIZONTAL = 10
export const NODE_SPACING_VERTICAL = 16
export const NODE_COLLAPSED_SPACING_VERTICAL = 12
export const TEXT_BOX_PADDING_Y = 2
export const TEXT_BOX_PADDING_X = 6
export const STROKE_WIDTH = 3

export const INHERITANCE_ARROW_RADIUS = 5
export const INHERITANCE_ARROW_HEIGHT =
  INHERITANCE_ARROW_RADIUS +
  INHERITANCE_ARROW_RADIUS * Math.sin(mathUtils.degreesToRadians(30))

export const REPLACEMENT_LINE_PADDING = 10
export const REPLACEMENT_LINE_X_COORDINATE = 2
export const TRIANGLE_HEAD_RADIUS = 4
